import { Box, Stack } from '@mui/material';
import { useEffect, useRef } from 'react';
import type useSWRInfinite from 'swr/infinite';
import Spinner from '/@/components/spinner';

const InfiniteLoader = ({
    infiniteQuery,
    pageSize,
}: {
    infiniteQuery: ReturnType<typeof useSWRInfinite>;
    pageSize: number;
}) => {
    const endOfFieldListRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (!endOfFieldListRef.current) return;

        if (infiniteQuery.size * pageSize >= infiniteQuery.data?.[0]?.count || 0) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !infiniteQuery.isValidating) {
                        infiniteQuery.setSize(infiniteQuery.size + 1);
                    }
                });
            },
            { threshold: 0.2 }
        );

        observer.observe(endOfFieldListRef.current);

        return () => {
            observer.disconnect();
        };
    }, [infiniteQuery]);

    return (
        <>
            <Box sx={{ height: '2px' }} ref={endOfFieldListRef} />
            {infiniteQuery.isValidating && !infiniteQuery.isLoading && (
                <Stack justifyContent='center' alignItems='center' my={2}>
                    <Spinner />
                </Stack>
            )}
        </>
    );
};

export default InfiniteLoader;
